(function () {
  'use strict';

  angular.module('ringbaPortal').component('changelog', {
    controller: ChangelogController,
    controllerAs: 'vm',
    bindings: {
      user: '<',
      objectId: '@',
      customClass: '@',
      wide: '<'
    },
    templateUrl: '/scripts/shared/components/changelog/changelog.view.html'
  });

  function ChangelogController(
    _,
    $q,
    accountsService,
    bsLoadingOverlayService,
    changelogService,
    moment
  ) {
    'ngInject';

    const vm = this;
    const _memoizedDateObject = _.memoize(_returnDateObject);
    let offset = 0;
    let endDateForChangeLogRequest = null;

    vm.shouldCheckForMoreLogs = true;
    vm.changeLoaderReference = 'changelogLoader';
    vm.datesShown = [];
    vm.groupedChangelogs = {};
    vm.groupedTransactionIds = {};
    vm.loadingLogs = false;

    vm.$onInit = onInit;
    vm.loadMoreChangelogs = loadMoreChangelogs;
    vm.showChangelogDetails = showChangelogDetails;

    function onInit() {
      _loadChangelog();
      _setWideView();
    }

    function loadMoreChangelogs() {
      if (vm.loadingLogs || !vm.shouldCheckForMoreLogs) {
        return;
      }

      offset = endDateForChangeLogRequest ? 0 : offset + changelogService.getChangelogRequestLimit();
      _loadChangelog();
    }

    function showChangelogDetails(changelog) {
      vm.changelogDetails = changelog;
    }

    function _loadChangelog() {
      let promise;
      const data = {
        offset: offset,
        limit: changelogService.getChangelogRequestLimit(),
        end: endDateForChangeLogRequest
      };

      _isLoaderVisible(true);

      if (vm.objectId && vm.objectId.length > 0) {
        promise = changelogService.getAccountChangelogByObject(accountsService.currentAccountId, vm.objectId, data);
      } else if (vm.user) {
        data.userName = accountsService.currentUserName;
        promise = changelogService.getAccountChangelogByUsername(accountsService.currentAccountId, data);
      } else {
        promise = changelogService.getAccountChangelog(accountsService.currentAccountId, data);
      }

      promise.then(function (response) {
        if (response.logs && response.logs.length) {
          _groupLogs(response.logs, vm.groupedChangelogs, vm.groupedTransactionIds);
          vm.groupedChangelogs = angular.copy(vm.groupedChangelogs);
          vm.datesShown = _setDatesToBeShown(vm.groupedChangelogs);
        }

        vm.shouldCheckForMoreLogs = response.checkMoreLogs;
        endDateForChangeLogRequest = response.endDateForNextRequest;
      }).finally(function () {
        _isLoaderVisible(false);
      });

      return promise;
    }

    function _setDatesToBeShown(groupedLogs) {
      const dates = _.sortBy(Object.keys(groupedLogs), function (date) {
        return _memoizedDateObject(date);
      });

      return dates.reverse();
    }

    function _groupLogs(newLogs, existingLogs, existingGroupedTransactionIds) {
      _.forEach(newLogs, function (log) {
        const formattedDate = _formatDate(log.dtStamp);

        try {
          log.diff = JSON.parse(log.diff);
        } catch {
          //
        }

        if ((log.primaryAction || moment(log.dtStamp).isBefore('2019-04-22')) && log.typeName !== 'RingbaAccount') {
          _checkIVRCreateLog(log);

          existingLogs[formattedDate] = existingLogs[formattedDate] || [];
          existingLogs[formattedDate].push(log);
          existingGroupedTransactionIds[log.transactionId] = [];
        } else {
          existingGroupedTransactionIds[log.transactionId] = existingGroupedTransactionIds[log.transactionId] || [];
          existingGroupedTransactionIds[log.transactionId].push(log);
        }
      });
    }

    function _checkIVRCreateLog(log) {
      if (log && log.typeName == 'IVRTree' && log.diff && log.diff.length === 2 && log.diff[0] === null) {
        log.action = 'Create';
      }
    }

    function _isLoaderVisible(isVisible) {
      if (isVisible) {
        vm.loadingLogs = true;
        bsLoadingOverlayService.start({
          referenceId: vm.changeLoaderReference
        });
      } else {
        vm.loadingLogs = false;
        bsLoadingOverlayService.stop({
          referenceId: vm.changeLoaderReference
        });
      }
    }

    function _formatDate(date) {
      return moment(date).format('MMMM D, YYYY');
    }

    function _returnDateObject(date) {
      return new Date(date);
    }

    function _setWideView(){
      // Use provided wide binding if available, otherwise calculate based on objectId
      if (typeof vm.wide !== 'undefined') {
        return;
      }
      vm.wide = false;
      if (vm.objectId && vm.objectId.indexOf('CA') === 0) {
        vm.wide = true;
      }
    }
  }
})();
